import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { SIGN_IN_PATH } from 'routes/constants.routes'
import { ErrorBoundary } from 'asterX-UI'
import { useAuthStore } from 'context/AuthStore'
import { ContractStoreProvider } from 'context/ContractStore'
import { ApplicationStoreProvider } from '../context/ApplicationStore'

const ContractPrivateRoute = ({ component: Component, componentProps = {}, ...rest }) => {
  const { authStore } = useAuthStore()
  return (
    <Route
      {...rest}
      render={props =>
        authStore.isLoggedIn ? (
          <ErrorBoundary>
            <ApplicationStoreProvider autoFetch={false}>
            <ContractStoreProvider>
              <Component {...props} {...componentProps} />
            </ContractStoreProvider>
            </ApplicationStoreProvider>
          </ErrorBoundary>
        ) : (
          <Redirect to={SIGN_IN_PATH} />
        )
      }
    />
  )
}

export default ContractPrivateRoute
